import { observer } from 'mobx-react-lite';
import { Card, Text, Stack } from '@instamenu/ui-system-next';
import { DateTime } from 'luxon';
import { themeVars } from '@instamenu/ui-vanilla-extract';
import {
  orderScheduleTimeSlot,
  orderScheduleTimeSlots,
  orderScheduleTimeSlotText,
} from './order-schedule.css';

export type OrderTimeSlotProps = {
  options: { startTime: DateTime; endTime: DateTime }[];
  value?: DateTime;
  onChange: (time: DateTime) => void;
};

export const OrderTimeSlots = observer((props: OrderTimeSlotProps) => {
  return (
    <Stack className={orderScheduleTimeSlots}>
      {props.options.map(({ startTime, endTime }) => (
        <Card
          className={orderScheduleTimeSlot}
          css={{
            border:
              props.value?.toSeconds() === startTime.toSeconds()
                ? `1px solid ${themeVars.color.brand}`
                : '',
          }}
          onClick={() => props.onChange(startTime)}
          data-id="order-schedule-slot"
          key={startTime.toSeconds()}
        >
          <Text className={orderScheduleTimeSlotText} variant="caption2">
            {startTime.toFormat('h:mm a')} - {endTime.toFormat('h:mm a')}
          </Text>
        </Card>
      ))}
    </Stack>
  );
});
